export default __webpack_public_path__ + "static/media/avatar3.37c832d1.png";